<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-primary">
          <form @submit.prevent>
            <div class="box-body">
              <div class="form-group col-md-10">
                <label for="inputName">Name</label>
                <h1 style="margin-top:0px;">
                  <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Name" v-model="formData.name">
                </h1>                        
              </div>
              <div class="form-group col-md-2">
              </div>                                 
              <div class="row">
                <div class="col-md-12">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li v-bind:class="{ active: tabActive == TAB_OVERVIEW }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">Overview</a></li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div v-bind:class="{ active: tabActive == TAB_OVERVIEW }" class="tab-pane" id="tab_1">
                      <div class="box no-border form-horizontal">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputUsingPassCode" class="col-sm-4 control-label">Using PassCode</label>
                              <div class="col-md-8">
                                <input :disabled="viewMode == MODE_VIEW" type="checkbox" id="inputUsingPassCode" v-model="formData.using_passcode">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">                      
                          </div>
                        </div>                       
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <input type="hidden" class="form-control" v-model="formData.id"> 
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
              </div>
            </div>

          </form>
        </div>          
      </div>
    </div>
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const MODE_NONE = 'none'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_OVERVIEW = 'tabOverview'

export default {
  name: 'PaymentMethodForm',
  components: {
    datepicker
  },
  data() {
    return {
      callback: '',
      DATE_FORMAT: config.dateFormat,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_OVERVIEW: TAB_OVERVIEW,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        payment_method: '',
        using_passcode: false
      },
      tabActive: '',
      originalcallback: '',
      prevRoute: null
    }
  },
  computed: {
  },
  created() {
    this.formData.id = this.$route.params.id
    this.viewMode = this.$route.params.mode
    this.callback = this.$route.params.callback
    this.callbackId = this.$route.params.callbackId
    this.originalcallback = this.$route.params.originalcallback
    this.tabActive = TAB_OVERVIEW
    this.getDetail()
  },
  mounted() {
  },
  methods: {
    getDetail() {
      let baseUrl = config.environment === 'Local' ? '/api/Gate/' : '/api/Gate/' + this.$store.state.userInfo.projects[0] + '/'
      api
        .request('Gate', 'get', baseUrl + 'PaymentMethod/' + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.formData = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onBack() {
      let params = {
        mode: MODE_VIEW,
        callbackId: this.callbackId,
        callback: this.callback
      }
      this.$router.push({ name: this.callback, params: params })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// PaymentMethodForm.vue?1a3f7c17